<div mat-dialog-title>{{title?title:('areYouSure'|translate)}}</div>
<div mat-dialog-actions fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="8px">
  <button mat-raised-button (click)="no()">{{'no' | translate}}</button>
  <button mat-raised-button (click)="yes()">{{'yes' | translate}}</button>
</div>